/* unplugin-vue-components disabled */import { render } from "./Unfolding3DSelector.vue?vue&type=template&id=0343083e&scoped=true"
import script from "./Unfolding3DSelector.vue?vue&type=script&lang=js"
export * from "./Unfolding3DSelector.vue?vue&type=script&lang=js"

import "./Unfolding3DSelector.vue?vue&type=style&index=0&id=0343083e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0343083e"]])

export default __exports__